import type { ESQueryExecutionModel } from '@repo/api-codegen';
import { useMemo } from 'react';
import {
	CostRender,
	LastUpdatedRender,
	RuntimeRender,
	SingleOwnerRender,
} from '../../../../components/TableV2/render';
import type { ExtendedDataTableColumn } from '../../../../components/TableV2/types';

export const useColumns = (
	fromDrawer: boolean
): ExtendedDataTableColumn<ESQueryExecutionModel>[] =>
	useMemo(
		() => [
			{
				accessor: 'started_at',
				titleLabel: 'Date',
				render: (record) => (
					<LastUpdatedRender record={record} field={'started_at'} />
				),
			},
			{
				accessor: 'user',
				titleLabel: fromDrawer ? 'Initiated by' : 'User',
				render: (record) => <SingleOwnerRender record={record} />,
			},
			{
				accessor: 'runtime',
				titleLabel: fromDrawer ? 'Duration' : 'Runtime',
				render: (record) => <RuntimeRender record={record} />,
			},
			{
				accessor: 'estimated_cost',
				titleLabel: 'Cost',
				render: (record) => <CostRender record={record} />,
			},
		],
		[fromDrawer]
	);
